export const SOCIAL_PROOF_SETTINGS_KEY = "social_proof_config";

export type SocialProofConfig = {
  /** Visa social proof-widgeten med antal användare */
  enabled: boolean;
};

export const defaultSocialProofConfig = (): SocialProofConfig => ({ enabled: true });

export const mergeSocialProofConfig = (stored: unknown): SocialProofConfig => {
  const base = defaultSocialProofConfig();
  if (!stored || typeof stored !== "object") return base;
  const raw = stored as Partial<SocialProofConfig>;
  return { enabled: typeof raw.enabled === "boolean" ? raw.enabled : base.enabled };
};
